/**
 * 旅CUBE版の表示をするか判定する。
 * @param referrer referrerパラメーターの値。
 * @returns 旅CUBE版の表示をするか判定した結果。
 */
export function isTabiCube(referrer: string | null) {
  return referrer !== 'airport_access';
}
